import React, { useEffect, useRef, useState } from "react";
import styles from "../AddTrip.module.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { get, post } from "../../../../components/api";
import { SweetAlert } from "../../../../helpers/helper";
import DatePicker from "react-datepicker";
import { ReactSelect } from "../../../../components/ReactSelect";

const UpdateTrip = () => {
  // const [documentName, setDocumentName] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [clientConsignor, setClientConsignor] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [routeDetails, setRouteDetails] = useState({});
  const [data, setData] = useState({});
  const FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "application/pdf",
  ];
  const [step, setStep] = useState(1);
  const getValidationSchema = (step) => {
    switch (step) {
      case 1:
        return Yup.object({
          tripName: Yup.string().required("Trip Name is required"),
          vehicleNumber: Yup.object().required("Vehicle Number is required"),
          consigorName: Yup.object().required("Consigor’s Name is required"),
          consigneeName: Yup.string().required("Consignee’s Name is required"),
          driver: Yup.object().required("Driver is required"),
          documents: Yup.array()
            .of(
              Yup.object()
                .shape({
                  name: Yup.string()
                    .nullable()
                    .max(100, "Document name too long"),
                  file: Yup.mixed()
                    .nullable()
                    .test("fileSize", "File too large", function (value) {
                      if (!value) return true; // Skip if empty
                      return value.size <= FILE_SIZE;
                    })
                    .test("fileFormat", "Unsupported Format", function (value) {
                      if (!value) return true; // Skip if empty
                      return SUPPORTED_FORMATS.includes(value.type);
                    }),
                })
                .test(
                  "both-or-none",
                  "Either both name and file are required or both empty",
                  function (value) {
                    const { name, file } = value || {};
                    const hasName = !!name;
                    const hasFile = !!file;

                    // Valid if both are filled or both are empty
                    return (hasName && hasFile) || (!hasName && !hasFile);
                  }
                )
            )
            .notRequired(),
        });
      case 2:
        return Yup.object({
          route: Yup.object().required("Route is required"),
          originLocation: Yup.string().required("origin is required"),
          originReportingTime: Yup.date().required("Origin Time is Required"),
          loadingTime: Yup.number().required(
            "loading time in hours is required"
          ),
          originStartTime: Yup.date().required("Route start Time"),
          destinationLocation: Yup.string().required("origin is required"),
          destinationReportingTime: Yup.date().required(
            "Origin Time is Required"
          ),
          unloadingTime: Yup.number().required(
            "loading time in hours is required"
          ),
          routeEndTime: Yup.date().required("Route start Time"),
          tripBuffer: Yup.number(),
        });
      case 3:
        return Yup.object({
          rtoExpense: Yup.number(),
          driverSalary: Yup.number(),
          driverExpense: Yup.number(),
          mileage: Yup.number(),
          fuelCostSaving: Yup.number(),
          otherExpense: Yup.object(),
          totalTime: Yup.number(),
          totalDistance: Yup.number(),
          totalBudget: Yup.number(),
        });
      default:
        return Yup.object();
    }
  };

  const fetchTrip = async () => {
    const response = await get(`admin/tms/get/trip/67fcf569390956e5b76aeee8`);
    if (response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    fetchTrip();
  }, []);

  const getVehicleList = async () => {
    const response = await get("admin/vehicles-list");

    if (response.status == 200) {
      const data = response.data.map((data) => ({
        _id: data._id,
        name: data.vehicleNo,
      }));
      setVehicleList(data);
    } else {
      SweetAlert("Error in fetching vehicle", true);
    }
  };

  const getClientList = async (type) => {
    const response = await post("admin/tms/list/clients", { type });

    if (response.status == 200) {
      setClientConsignor(response.data);
    } else {
      SweetAlert("Error in fetching consignsor", true);
    }
  };
  const getDriverList = async () => {
    const response = await get("admin/tms/list/driver");
    if (response.status == 200) {
      setDriverList(response.data);
    } else {
      SweetAlert("Error in fetching consignsor", true);
    }
  };

  const getRouteList = async () => {
    const response = await get("admin/tms/route-list");
    if (response.status == 200) {
      const updatedArray = response.data.map((data) => {
        return { _id: data._id, name: data.routeName };
      });
      setRouteList(updatedArray);
    } else {
      SweetAlert("error in fetching route", true);
    }
  };

  const getRouteDetails = async (id) => {
    const response = await get(`admin/tms/routes/${id}`);
    if (response.status == 200) {
      setRouteDetails(response.data);
    } else {
      SweetAlert("error fetching route details", true);
    }
  };

  useEffect(() => {
    getVehicleList();
    getClientList("Consignor");
    getDriverList();
    getRouteList();
  }, []);

  const DocumentUpload = ({ formik, index }) => {
    const fileInputRef = useRef();

    const handleNameChange = (e) => {
      const updatedDocuments = [...formik.values.documents];
      updatedDocuments[index].name = e.target.value;
      formik.setFieldValue("documents", updatedDocuments);
    };
    // setDocumentName((pre) => prev[index].fileName)
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const updatedDocuments = [...formik.values.documents];
        updatedDocuments[index].file = file;
        formik.setFieldValue("documents", updatedDocuments);
      }
    };

    const cancleDocumnet = (index) => {
      const updatedDocuments = [...formik.values.documents];
      updatedDocuments.splice(index, 1);
      updatedDocuments.push({ name: "", file: null });
      formik.setFieldValue("documents", updatedDocuments);
    };

    return (
      <div className="col-md-6 col-lg-6 col-12 mb-3">
        <label className="route-label mb-2">Document Name</label>
        <div className={styles.DocumentDiv} style={{ position: "relative" }}>
          <input
            className="form-control input-field"
            placeholder="Enter Document Name"
            value={formik.values.documents[index]?.name || ""}
            onChange={handleNameChange}
          />
          <div className={styles.svg}>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <svg
              width="43"
              height="41"
              viewBox="0 0 63 61"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => fileInputRef.current.click()}
              style={{
                cursor: "pointer",
              }}
            >
              <rect width="63" height="60.48" rx="10.08" fill="#EEF2F4" />
              <path
                d="M41.4815 24.6714L34.8665 18.0564C34.7349 17.9246 34.5785 17.8201 34.4065 17.7487C34.2344 17.6774 34.0499 17.6406 33.8636 17.6406H22.5236C21.8971 17.6406 21.2961 17.8895 20.8531 18.3326C20.41 18.7756 20.1611 19.3766 20.1611 20.0031V40.7931C20.1611 41.4197 20.41 42.0206 20.8531 42.4637C21.2961 42.9067 21.8971 43.1556 22.5236 43.1556H39.5336C40.1602 43.1556 40.7611 42.9067 41.2042 42.4637C41.6472 42.0206 41.8961 41.4197 41.8961 40.7931V25.6731C41.8961 25.2975 41.747 24.9372 41.4815 24.6714ZM37.5255 24.7281H34.8086V22.0113L37.5255 24.7281ZM22.9961 40.3206V20.4756H31.9736V26.1456C31.9736 26.5216 32.123 26.8821 32.3888 27.1479C32.6546 27.4138 33.0152 27.5631 33.3911 27.5631H39.0611V40.3206H22.9961ZM34.8665 31.7577C35.1328 32.024 35.2824 32.3852 35.2824 32.7618C35.2824 33.1384 35.1328 33.4996 34.8665 33.7659C34.6002 34.0322 34.239 34.1818 33.8625 34.1818C33.4859 34.1818 33.1247 34.0322 32.8584 33.7659L32.4461 33.3512V37.0131C32.4461 37.3891 32.2968 37.7496 32.031 38.0154C31.7651 38.2813 31.4046 38.4306 31.0286 38.4306C30.6527 38.4306 30.2921 38.2813 30.0263 38.0154C29.7605 37.7496 29.6111 37.3891 29.6111 37.0131V33.3512L29.1965 33.767C28.9302 34.0333 28.569 34.1829 28.1925 34.1829C27.8159 34.1829 27.4547 34.0333 27.1884 33.767C26.9221 33.5008 26.7725 33.1396 26.7725 32.763C26.7725 32.3864 26.9221 32.0252 27.1884 31.7589L30.0234 28.9239C30.1551 28.7918 30.3116 28.6869 30.4839 28.6154C30.6562 28.5438 30.8409 28.507 31.0275 28.507C31.214 28.507 31.3987 28.5438 31.571 28.6154C31.7433 28.6869 31.8998 28.7918 32.0315 28.9239L34.8665 31.7577Z"
                fill="#4C7889"
              />
            </svg>
            {formik.values.documents[index]?.file && (
              <div className={styles.cancleDocumnet}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => cancleDocumnet(index)}
                >
                  <circle cx="11" cy="11" r="11" fill="white" />
                  <circle
                    cx="11"
                    cy="11"
                    r="10.7708"
                    stroke="#4C7889"
                    strokeOpacity="0.5"
                    strokeWidth="0.458333"
                  />
                  <path
                    d="M15.2904 7.33398L7.33325 15.584"
                    stroke="#4C7889"
                    strokeWidth="1.375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.33325 7.33398L15.2904 15.584"
                    stroke="#4C7889"
                    strokeWidth="1.375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
        <div
          className={`${styles.fileName} ${
            formik?.errors?.documents && formik?.touched?.documents
              ? "justify-content-between"
              : "justify-content-end"
          }`}
        >
          {formik?.touched?.documents && formik?.errors?.documents ? (
            <div className="field-error ">{formik.errors.documents[index]}</div>
          ) : (
            ""
          )}

          <p>{formik.values.documents[index]?.file?.name || ""}</p>
        </div>
      </div>
    );
  };

  const handleSubmit = async (values, resetForm) => {
    const formData = new FormData();

    formData.append("tripName", values.tripName);
    formData.append("vehicleNumber", JSON.stringify(values.vehicleNumber));
    formData.append("consigorName", JSON.stringify(values.consigorName));
    formData.append("consigneeName", values.consigneeName);
    formData.append("driver", JSON.stringify(values.driver));
    formData.append("route", JSON.stringify(values.route));
    values.documents.forEach((doc) => {
      if (doc.file) {
        formData.append("documents", JSON.stringify({ name: doc.name }));
        formData.append(doc.name, doc.file);
      }
    });
    formData.append("originLocation", values.originLocation);
    formData.append("originReportingTime", values.originReportingTime);
    formData.append("loadingTime", values.loadingTime);
    formData.append("originStartTime", values.originStartTime);
    formData.append("destinationLocation", values.destinationLocation);
    formData.append(
      "destinationReportingTime",
      values.destinationReportingTime
    );
    formData.append("unloadingTime", values.unloadingTime);
    formData.append("routeEndTime", values.routeEndTime);
    formData.append("tripBuffer", values.tripBuffer);
    formData.append("rtoExpense", values.rtoExpense);
    formData.append("driverSalary", values.driverSalary);
    formData.append("driverExpense", values.driverExpense);
    formData.append("mileage", values.mileage);
    formData.append("fuelCostSaving", values.fuelCostSaving);
    formData.append("otherExpense", values.otherExpense);
    formData.append("totalTime", values.totalTime);
    formData.append("totalDistance", values.totalDistance);
    formData.append("totalBudget", values.totalBudget);

    const response = await post("admin/tms/add/trip", formData);
    if (response.status == 200) {
      SweetAlert("Trip Added Successfully", false);
      resetForm();
    } else {
      SweetAlert(response?.message || "error adding trip", true);
    }
  };

  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadingDiv}>
        <div className={`${styles.Heading} ${styles.CompletedHeading}`}>
          <p>Add Trip</p>
        </div>
        <div>
          {step < 2 ? (
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.3335 14.3333L17.0002 7.66667L10.3335 1"
                stroke="#DFE1E6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1 14.3333L7.66667 7.66667L1 1"
                stroke="#DFE1E6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="23"
              height="20"
              viewBox="0 0 28 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.0527 21.5281L26.3167 11.264L16.0527 1"
                stroke="#1D262F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.68311 21.5281L11.9471 11.264L1.68311 1"
                stroke="#1D262F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <div
          className={`${styles.Heading} ${
            step >= 2 ? styles.CompletedHeading : null
          }`}
        >
          <p>Route Details</p>
        </div>
        <div>
          {step > 2 ? (
            <svg
              width="23"
              height="20"
              viewBox="0 0 28 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.0527 21.5281L26.3167 11.264L16.0527 1"
                stroke="#1D262F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.68311 21.5281L11.9471 11.264L1.68311 1"
                stroke="#1D262F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.3335 14.3333L17.0002 7.66667L10.3335 1"
                stroke="#DFE1E6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1 14.3333L7.66667 7.66667L1 1"
                stroke="#DFE1E6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <div
          className={`${styles.Heading} ${
            step >= 3 ? styles.CompletedHeading : null
          }`}
        >
          <p>Trip Expense</p>
        </div>
      </div>
      <div className={styles.ContentDiv}>
        <Formik
          enableReinitialize
          initialValues={{
            tripName: data?.tripName,
            vehicleNumber: vehicleList.find((d) => d._id == data.vehicleId),
            consigorName: clientConsignor.find(
              (d) => d._id == data.consigorClientId
            ),
            consigneeName: data?.consigneeClient,
            driver: driverList.find((d) => d._id == data?.driverId),
            documents: data.documents || [{ name: "", file: null }],

            // step 2
            route: "",
            originLocation: "",
            originReportingTime: new Date(),
            loadingTime: "",
            originStartTime: "",
            destinationLocation: "",
            destinationReportingTime: "",
            unloadingTime: "",
            routeEndTime: "",
            tripBuffer: "",

            // step 3
            rtoExpense: 0,
            driverSalary: 0,
            driverExpense: 0,
            mileage: 0,
            fuelCostSaving: "",
            otherExpense: { name: "", value: 0 },
            totalTime: "",
            totalDistance: "",
            totalBudget: 0,
          }}
          validationSchema={getValidationSchema(step)}
          onSubmit={(values, { resetForm }) => {
            if (step === 3) {
              handleSubmit(values, resetForm);
            } else {
              setStep(step + 1);
            }
          }}
        >
          {(formik) => {
            useEffect(() => {
              const { originReportingTime, loadingTime } = formik.values;

              if (originReportingTime && loadingTime !== "") {
                const startTime = new Date(originReportingTime);
                startTime.setHours(startTime.getHours() + Number(loadingTime));
                formik.setFieldValue("originStartTime", startTime);
              }
            }, [formik.values.originReportingTime, formik.values.loadingTime]);
            useEffect(() => {
              const { destinationReportingTime, unloadingTime } = formik.values;

              if (destinationReportingTime && unloadingTime !== "") {
                const startTime = new Date(destinationReportingTime);
                startTime.setHours(
                  startTime.getHours() + Number(unloadingTime)
                );
                formik.setFieldValue("routeEndTime", startTime);
              }
            }, [
              formik.values.destinationReportingTime,
              formik.values.unloadingTime,
            ]);
            useEffect(() => {
              if (
                routeDetails &&
                Array.isArray(routeDetails.routePoints) &&
                routeDetails.routePoints.length > 0 &&
                routeDetails.routePoints[0].address
              ) {
                formik.setFieldValue(
                  "originLocation",
                  routeDetails.routePoints[0].address
                );
                formik.setFieldValue(
                  "destinationLocation",
                  routeDetails.routePoints[routeDetails.routePoints.length - 1]
                    .address
                );
                const totalDistance = routeDetails.routePoints
                  .slice(0, -1)
                  .reduce((sum, point) => sum + (point.distance || 0), 0);
                formik.setFieldValue("totalDistance", totalDistance);
              }
            }, [routeDetails]);
            useEffect(() => {
              if (step === 3) {
                const { originReportingTime, routeEndTime, tripBuffer } =
                  formik.values;

                if (
                  originReportingTime &&
                  routeEndTime &&
                  tripBuffer !== undefined
                ) {
                  const start = new Date(originReportingTime);
                  const end = new Date(routeEndTime);

                  const diffMs = end - start; // difference in milliseconds
                  if (diffMs >= 0) {
                    const diffMinutes = Math.floor(diffMs / (1000 * 60));
                    const bufferMinutes = tripBuffer * 60;

                    const totalMinutes = diffMinutes + bufferMinutes;
                    const totalHours = totalMinutes / 60;
                    formik.setFieldValue("totalTime", totalHours);
                  }
                }
              }
            }, [step]);

            useEffect(() => {
              const budget =
                parseInt(formik.values.rtoExpense) +
                parseInt(formik.values.driverSalary) +
                parseInt(formik.values.driverExpense) +
                +parseInt(formik.values.otherExpense.value) +
                (formik.values.mileage > 0
                  ? parseInt(90 * formik.values.totalDistance) /
                    formik.values.mileage
                  : 0);
              formik.setFieldValue("totalBudget", budget);
            }, [
              formik.values.rtoExpense,
              formik.values.driverSalary,
              formik.values.driverExpense,
              formik.values.otherExpense.value,
              formik.values.mileage,
              formik.values.totalDistance,
            ]);

            return (
              <Form>
                <div className="row">
                  {step == 1 && (
                    <>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">Trip Name</label>
                        <input
                          className="form-control input-field"
                          id="tripName"
                          name="tripName"
                          placeholder="Enter Trip Name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.tripName}
                        />
                        {formik.touched.tripName && formik.errors.tripName ? (
                          <div className="field-error ">
                            {formik.errors.tripName}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">Vehicle</label>
                        <ReactSelect
                          name="vehicleNumber"
                          value={formik.values.vehicleNumber}
                          options={vehicleList}
                          handleOnChange={(name, value) => {
                            return formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          noOptionsMessage="vehicle not availables."
                          placeholder="Select vehicle"
                        />
                        {formik.touched.vehicleNumber &&
                          formik.errors.vehicleNumber && (
                            <div className="field-error ">
                              {formik.errors.vehicleNumber}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Enter Consigor’s Name
                        </label>
                        <ReactSelect
                          name="consigorName"
                          value={formik.values.consigorName}
                          options={clientConsignor}
                          handleOnChange={(name, value) => {
                            return formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          noOptionsMessage="Consigor’s Name not availables."
                          placeholder="Select Consigor’s Name"
                        />
                        {formik.touched.consigorName &&
                          formik.errors.consigorName && (
                            <div className="field-error ">
                              {formik.errors.consigorName}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Enter Consignee’s Name
                        </label>
                        <input
                          className="form-control input-field"
                          id="consigneeName"
                          name="consigneeName"
                          placeholder="Enter Consignee’s Name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.consigneeName}
                        />
                        {formik.touched.consigneeName &&
                          formik.errors.consigneeName && (
                            <div className="field-error ">
                              {formik.errors.consigneeName}
                            </div>
                          )}
                      </div>
                      <div className={styles.FormHeading}>
                        Driver Information
                      </div>
                      <hr style={{ opacity: 1, color: "rgb(136, 141, 147)" }} />
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Select Driver
                        </label>
                        <ReactSelect
                          name="driver"
                          value={formik.values.driver}
                          options={driverList}
                          handleOnChange={(name, value) => {
                            return formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          noOptionsMessage="Driver's Name not availables."
                          placeholder="Select Driver's Name"
                        />
                        {formik.touched.driver && formik.errors.driver && (
                          <div className="field-error ">
                            {formik.errors.driver}
                          </div>
                        )}
                      </div>
                      <div className={styles.FormHeading}>Documents</div>
                      <hr style={{ opacity: 1, color: "rgb(136, 141, 147)" }} />
                      <DocumentUpload formik={formik} index={0} />
                      <DocumentUpload formik={formik} index={1} />
                      <DocumentUpload formik={formik} index={2} />
                      <DocumentUpload formik={formik} index={2} />
                    </>
                  )}
                  {step == 2 && (
                    <>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">Select Route</label>
                        <ReactSelect
                          name="route"
                          value={formik.values.route}
                          options={routeList}
                          handleOnChange={(name, value) => {
                            getRouteDetails(value._id);
                            return formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          noOptionsMessage="route not availables."
                          placeholder="Select route"
                        />
                        {formik.touched.route && formik.errors.route && (
                          <div className="field-error ">
                            {formik.errors.route}
                          </div>
                        )}
                      </div>
                      <div className={styles.FormHeading}>Origin</div>
                      <hr style={{ opacity: 1, color: "rgb(136, 141, 147)" }} />
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Starting Location*
                        </label>
                        <input
                          className="form-control input-field"
                          id="originLocation"
                          name="originLocation"
                          placeholder="Enter Origin Location"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.originLocation}
                          readOnly
                        />
                        {formik.touched.originLocation &&
                          formik.errors.originLocation && (
                            <div className="field-error ">
                              {formik.errors.originLocation}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Origin Reporting Time*
                        </label>
                        <DatePicker
                          id="originReportingTime"
                          name="originReportingTime"
                          selected={formik.values.originReportingTime}
                          onChange={(date) =>
                            formik.setFieldValue("originReportingTime", date)
                          }
                          onBlur={formik.handleBlur}
                          showTimeSelect
                          timeFormat="HH:mm"
                          maxDate={Date.now()}
                          dateFormat={"dd/MM/yyyy hh:mm"}
                        />
                        {formik.touched.originReportingTime &&
                          formik.errors.originReportingTime && (
                            <div className="field-error ">
                              {formik.errors.originReportingTime}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Loading Time(hours)*
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="loadingTime"
                          name="loadingTime"
                          placeholder="00 hours "
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.loadingTime}
                          min={0}
                        />
                        {formik.touched.loadingTime &&
                          formik.errors.loadingTime && (
                            <div className="field-error ">
                              {formik.errors.loadingTime}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Route Start Time*
                        </label>
                        <DatePicker
                          id="originStartTime"
                          name="originStartTime"
                          selected={formik.values.originStartTime}
                          onChange={(date) =>
                            formik.setFieldValue("originStartTime", date)
                          }
                          onBlur={formik.handleBlur}
                          showTimeSelect
                          timeFormat="HH:mm"
                          maxDate={Date.now()}
                          dateFormat={"dd/MM/yyyy hh:mm"}
                          readOnly
                        />
                        {formik.touched.originStartTime &&
                          formik.errors.originStartTime && (
                            <div className="field-error ">
                              {formik.errors.originStartTime}
                            </div>
                          )}
                      </div>
                      <div className={styles.FormHeading}>Destination</div>
                      <hr style={{ opacity: 1, color: "rgb(136, 141, 147)" }} />
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Destination Location *
                        </label>
                        <input
                          className="form-control input-field"
                          id="destinationLocation"
                          name="destinationLocation"
                          placeholder="Enter Consignee’s Name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.destinationLocation}
                        />
                        {formik.touched.destinationLocation &&
                          formik.errors.destinationLocation && (
                            <div className="field-error ">
                              {formik.errors.destinationLocation}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Destination Reporting Time*
                        </label>
                        <DatePicker
                          id="destinationReportingTime"
                          name="destinationReportingTime"
                          selected={formik.values.destinationReportingTime}
                          onChange={(date) =>
                            formik.setFieldValue(
                              "destinationReportingTime",
                              date
                            )
                          }
                          onBlur={formik.handleBlur}
                          minDate={formik.values.originStartTime}
                          showTimeSelect
                          timeFormat="HH:mm"
                          dateFormat={"dd/MM/yyyy hh:mm"}
                        />
                        {formik.touched.destinationReportingTime &&
                          formik.errors.destinationReportingTime && (
                            <div className="field-error ">
                              {formik.errors.destinationReportingTime}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Unloading Time(hours)*
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="unloadingTime"
                          name="unloadingTime"
                          placeholder="00 hours "
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.unloadingTime}
                          min={0}
                        />
                        {formik.touched.unloadingTime &&
                          formik.errors.unloadingTime && (
                            <div className="field-error ">
                              {formik.errors.unloadingTime}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Route End Time*
                        </label>
                        <DatePicker
                          id="routeEndTime"
                          name="routeEndTime"
                          selected={formik.values.routeEndTime}
                          onChange={(date) =>
                            formik.setFieldValue("routeEndTime", date)
                          }
                          onBlur={formik.handleBlur}
                          showTimeSelect
                          timeFormat="HH:mm"
                          // maxDate={Date.now()}
                          dateFormat={"dd/MM/yyyy hh:mm"}
                          disabled
                        />
                        {formik.touched.routeEndTime &&
                          formik.errors.routeEndTime && (
                            <div className="field-error ">
                              {formik.errors.originStartTime}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">Trip Buffer*</label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="tripBuffer"
                          name="tripBuffer"
                          placeholder="00 hours "
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.tripBuffer}
                          min={0}
                        />
                        {formik.touched.tripBuffer &&
                          formik.errors.tripBuffer && (
                            <div className="field-error ">
                              {formik.errors.tripBuffer}
                            </div>
                          )}
                      </div>
                    </>
                  )}
                  {step == 3 && (
                    <>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Enter RTO Expense*
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="rtoExpense"
                          name="rtoExpense"
                          placeholder="Enter RTO Expense"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.rtoExpense}
                        />
                        {formik.touched.rtoExpense &&
                          formik.errors.rtoExpense && (
                            <div className="field-error ">
                              {formik.errors.rtoExpense}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Driver Salary
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="driverSalary"
                          name="driverSalary"
                          placeholder="Enter Driver Salary"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.driverSalary}
                        />
                        {formik.touched.driverSalary &&
                          formik.errors.driverSalary && (
                            <div className="field-error ">
                              {formik.errors.driverSalary}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Driver Expense
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="driverExpense"
                          name="driverExpense"
                          placeholder="Enter Driver Expense"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.driverExpense}
                        />
                        {formik.touched.driverExpense &&
                          formik.errors.driverExpense && (
                            <div className="field-error ">
                              {formik.errors.driverExpense}
                            </div>
                          )}
                      </div>
                      <div className={styles.FormHeading}>Fuel Expense</div>
                      <hr style={{ opacity: 1, color: "rgb(136, 141, 147)" }} />
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Baseline Mileage (kmpl)
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="mileage"
                          name="mileage"
                          placeholder="Enter Fuel Mileage"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.mileage}
                        />
                        {formik.touched.mileage && formik.errors.mileage && (
                          <div className="field-error ">
                            {formik.errors.mileage}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                        <label className="route-label mb-2">
                          Fuel Cost Savings(pl)
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="fuelCostSaving"
                          name="fuelCostSaving"
                          placeholder="Enter cost Saving(pl)"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.fuelCostSaving}
                        />
                        {formik.touched.fuelCostSaving &&
                          formik.errors.fuelCostSaving && (
                            <div className="field-error ">
                              {formik.errors.fuelCostSaving}
                            </div>
                          )}
                      </div>
                      <div className="col-md-4 col-lg-4 col-xs-6 mb-3">
                        <label className="route-label mb-2">
                          Other Expenses
                        </label>
                        <input
                          className="form-control input-field"
                          id="otherExpense.name"
                          name="otherExpense.name"
                          placeholder="Enter Other Expense"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.otherExpense?.name}
                        />
                        {formik.touched.otherExpense?.name &&
                          formik.errors.otherExpense?.name && (
                            <div className="field-error ">
                              {formik.errors.otherExpense?.name}
                            </div>
                          )}
                      </div>
                      <div className="col-md-2 col-lg-2 col-xs-6 mb-3">
                        <label className="route-label mb-2">
                          Expences Value
                        </label>
                        <input
                          type="number"
                          className="form-control input-field"
                          id="otherExpense.value"
                          name="otherExpense.value"
                          placeholder="Enter Other Expense"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.otherExpense?.value}
                        />
                        {formik.touched.otherExpense?.value &&
                          formik.errors.otherExpense?.value && (
                            <div className="field-error ">
                              {formik.errors.otherExpense?.value}
                            </div>
                          )}
                      </div>
                      <div className="col-md-6 col-lg-6 col-xs-12">
                        <div className={`${styles.TotalDiv1} `}>
                          <div style={{ width: "40%" }}>
                            <div className={`${styles.topDiv}`}>
                              <label
                                className={styles.secondaryText}
                                style={{ marginBottom: "-2px" }}
                              >
                                Fuel Pricing - State Wise
                              </label>
                            </div>
                            <div className={`${styles.bottomDiv} `}>
                              <label className={`${styles.mainText}`}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    gap: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <svg
                                    width="18"
                                    height="23"
                                    viewBox="0 0 18 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M17 9.29448C17 15.7457 9 21.2754 9 21.2754C9 21.2754 1 15.7457 1 9.29448C1 7.09465 1.84285 4.98491 3.34315 3.4294C4.84344 1.87388 6.87827 1 9 1C11.1217 1 13.1566 1.87388 14.6569 3.4294C16.1571 4.98491 17 7.09465 17 9.29448Z"
                                      stroke="#4C7889"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9.00065 12.0589C10.4734 12.0589 11.6673 10.8211 11.6673 9.29412C11.6673 7.76715 10.4734 6.5293 9.00065 6.5293C7.52789 6.5293 6.33398 7.76715 6.33398 9.29412C6.33398 10.8211 7.52789 12.0589 9.00065 12.0589Z"
                                      stroke="#4C7889"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>{" "}
                                  Gujarat
                                </div>
                              </label>
                              <label className={`${styles.mainText}`}>
                                Fuel Charges {"  "}₹ 90.42/L
                              </label>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                              justifyContent: "start",
                            }}
                          >
                            <label className={`${styles.secondaryText}`}>
                              Cost, if fuel filled in respective states
                            </label>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                gap: "10px",
                                marginBottom: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <svg
                                width="18"
                                height="23"
                                viewBox="0 0 18 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 9.29448C17 15.7457 9 21.2754 9 21.2754C9 21.2754 1 15.7457 1 9.29448C1 7.09465 1.84285 4.98491 3.34315 3.4294C4.84344 1.87388 6.87827 1 9 1C11.1217 1 13.1566 1.87388 14.6569 3.4294C16.1571 4.98491 17 7.09465 17 9.29448Z"
                                  stroke="#4C7889"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M9.00065 12.0589C10.4734 12.0589 11.6673 10.8211 11.6673 9.29412C11.6673 7.76715 10.4734 6.5293 9.00065 6.5293C7.52789 6.5293 6.33398 7.76715 6.33398 9.29412C6.33398 10.8211 7.52789 12.0589 9.00065 12.0589Z"
                                  stroke="#4C7889"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>{" "}
                              <label className={`${styles.mainText}`}>
                                Gujarat
                              </label>
                            </div>
                            <label
                              style={{ marginLeft: "10px" }}
                              className={`${styles.mainText}`}
                            >
                              Total Petrol Expenses: ₹16442.28
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className={styles.FormHeading}>
                        Total Cost Expense
                      </div>
                      <hr style={{ opacity: 1, color: "rgb(136, 141, 147)" }} />
                      <div className="col-md-12 col-lg-12 col-xs-12 mb-3 mt-3">
                        <div className={styles.TotalDiv}>
                          <div
                            className="row"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div className="col-md-3 col-lg-3 col-xs-12 mb-3">
                              <label className={`${styles.label} `}>
                                Route name
                              </label>
                              <label className={`${styles.mainText}`}>
                                {step == 3 ? routeDetails.routeName : null}
                              </label>
                            </div>
                            <div className="col-md-1 col-lg-1 col-xs-12">
                              <svg
                                width="2"
                                height="63"
                                viewBox="0 0 2 63"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M1 0V63" stroke="#4C7889" />
                              </svg>
                            </div>
                            <div className="col-md-3 col-lg-3 col-xs-12">
                              <label className={`${styles.label}`}>
                                Total Distance
                              </label>
                              <label className={`${styles.mainText}`}>
                                {step == 3
                                  ? `Total ${formik.values.totalDistance}KM`
                                  : null}
                              </label>
                            </div>
                            <div className="col-md-1 col-lg-1 col-xs-12">
                              <svg
                                width="2"
                                height="63"
                                viewBox="0 0 2 63"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M1 0V63" stroke="#4C7889" />
                              </svg>
                            </div>
                            <div className="col-md-4 col-lg-4 col-xs-12">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <label className={`${styles.label}`}>
                                    Total Trip Time
                                  </label>
                                  <label className={`${styles.mainText}`}>
                                    {step == 3
                                      ? `${Math.floor(
                                          formik.values.totalTime
                                        )} Hours ${
                                          (formik.values.totalTime * 60) % 60
                                        } Minutes`
                                      : null}
                                  </label>
                                </div>
                                <div className={styles.TotalExpense}>
                                  <label className={`${styles.label}`}>
                                    Total expenses
                                  </label>
                                  <label className={`${styles.mainText}`}>
                                    INR {formik.values.totalBudget}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-12 col-lg-12 col-xs-12 mb-3">
                    <div className={styles.buttons}>
                      {/* {step !== 1 && ( */}
                      <button
                        type="button"
                        className={styles.CancelButton}
                        onClick={() => setStep((prev) => prev - 1)}
                      >{`< Prev`}</button>
                      {/* )} */}
                      <button type="submit" className={styles.SubmitButton}>
                        {step === 3 ? "Submit" : "Next"}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateTrip;
